export const statusTypeOfValues = {
  enum: 'enum',
  text: 'text',
};
